import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">关于我们</h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="flex-1 w-full">
            <div className="bg-background-100 rounded-2xl p-8 border border-background-200/60">
              <h3 className="font-heading text-xl text-foreground-900 mb-4">{aboutData.title}</h3>
              {aboutData.paragraphs.map((p, i) => (
                <p key={i} className="text-sm text-foreground-600 leading-relaxed mb-4 last:mb-0">
                  {p}
                </p>
              ))}
            </div>
          </div>

          <div className="flex-1 w-full">
            <div className="grid grid-cols-2 gap-4">
              {aboutData.stats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-background-100 rounded-xl p-5 border border-background-200/60 text-center"
                >
                  <div className="font-heading text-3xl md:text-4xl text-primary-500 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}